var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cardWrapper",attrs:{"tabindex":_vm.tabindex},on:{"click":function($event){return _vm.openStoriesModal(_vm.storyID)},"keypress":function($event){return _vm.openStoriesModal(_vm.storyID)}}},[_c('div',{staticClass:"cardInner"},[_c('div',{staticClass:"candidateImage",class:{
         Ailsa: _vm.storyID === 'Ailsa',
         Hamze: _vm.storyID === 'Hamze',
         David: _vm.storyID === 'David',
         Leonie: _vm.storyID === 'Leonie',
         Francesca: _vm.storyID === 'Francesca',
         Roy: _vm.storyID === 'Roy',
         Sengova: _vm.storyID === 'Sengova',
         Tony: _vm.storyID === 'Tony',}}),_vm._v(" "),_c('h3',{staticClass:"name"},[_vm._v(_vm._s(_vm.storyName))]),_vm._v(" "),_c('h3',{staticClass:"position"},[_vm._v(_vm._s(_vm.storyPosition))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9410808e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/stories/components/RareStoriesStoryCard.vue
// module id = null
// module chunks = 